import { Skeleton } from '@zoopla-eng/zds-components/skeleton';
import { Box } from '@zoopla-eng/zds-components/box';
import {
    skeletonCardStyles,
    skeletonImagesStyles,
    skeletonTextWrapperStyles,
    skeletonTitleStyles,
    skeletonPriceStyles,
    skeletonPOIStyles
} from './ListingCardMiniSkeleton.css';

type ListingCardMiniSkeletonProps = {
    testid?: string;
};

export const ListingCardMiniSkeleton = ({
    testid
}: ListingCardMiniSkeletonProps) => {
    return (
        <Box
            pb="S400"
            bpM100={{ pb: 'M300' }}
            data-testid={testid ?? 'mini-skeleton'}
        >
            <div className={skeletonCardStyles}>
                <div className={skeletonImagesStyles}>
                    <Skeleton.Root loadingText="Loading">
                        <Skeleton.Wave />
                    </Skeleton.Root>
                </div>
                <div className={skeletonTextWrapperStyles}>
                    <div className={skeletonTitleStyles}>
                        <Skeleton.Text />
                    </div>
                    <div className={skeletonPriceStyles}>
                        <Skeleton.Text />
                    </div>
                    <div className={skeletonPOIStyles}>
                        <Skeleton.Wave />
                        <Skeleton.Wave />
                        <Skeleton.Wave />
                    </div>
                </div>
            </div>
        </Box>
    );
};
